import JSEncrypt from 'jsencrypt';

interface ICardProps {
  cardNumber: string;
  month: string;
  year: string;
  codSec: string;
}

/**
 * Encrypts credit card information using the provided public key.
 *
 * @param {ICardProps} cardProps - Credit card information to encrypt.
 * @param {string} cardProps.cardNumber - Credit card number without spaces or special characters.
 * @param {string} cardProps.month - Credit card expiration month as a 2-digit string (01-12).
 * @param {string} cardProps.year - Credit card expiration year as a 2-digit or 4-digit string.
 * @param {string} cardProps.codSec - Credit card security code without spaces or special characters.
 * @returns {string} Encrypted credit card information.
 */
const encryptCard = ({
  cardNumber,
  codSec,
  month,
  year,
}: ICardProps): string => {
  const jsEncrypt = new JSEncrypt();

  jsEncrypt.setPublicKey(process.env.REACT_APP_COMUNIX_PK || '');

  const cardNumberFormatted = cardNumber.replace(/\D/g, '');
  const monthFormatted = month.length > 1 ? month : '0' + month;
  const yearFormatted = year.length > 2 ? year : '20' + year;
  const codSecFormatted = codSec.replace(/\D/g, '');

  const encrypted = jsEncrypt.encrypt(
    `${cardNumberFormatted};${monthFormatted};${yearFormatted};${codSecFormatted}`,
  );

  return encrypted || '';
};

export { encryptCard };